import AdminService from '@/services/admin.service'

export default function(propertyName) {
  return function(to, from, next) {
    const communityAbbreviation = to.params[propertyName]
    if (!communityAbbreviation) {
      next()
      return
    }
    AdminService.isCommunityConfidential(communityAbbreviation)
      .then(_ => next())
      .catch(error => {
        if (error.response.status === 403) {
          next('/forbidden')
        }
      })
  }
}